<template>
    <div class="nscp-contract-info">
        <div class="title-container">
            <span class="sub-title">附件信息<span class="tip">注意：上传附件大小不能超过{{ OSS_FILE_MAX_SIZE }}M</span></span>
            <i :class="contentVisible ? 'el-icon-arrow-down' : 'el-icon-arrow-up'" @click="handleCollapse"></i>
        </div>
        <div class="content" v-if="contentVisible">
            <el-row>
                <el-col class="has-bg center-text" :span="3">附件上传</el-col>
                <el-col class="center-text" :span="5">
                    <Upload
                        v-if="btnVisible"
                        text="点击上传"
                        uploadDisplayType="button"
                        icon="el-icon-upload2"
                        :disabled="uploading"
                        accept=".xlsx"
                        :fileTypeReg="/\.xlsx$/"
                        @uploadSuccess="handleUploadSuccess"
                    ></Upload>
                </el-col>
                <el-col class="has-bg center-text" :span="3">附件预览</el-col>
                <el-col class="center-text" :span="5">
                    <el-button v-if="formData.spotCheckFileName" type="text" size="mini" @click="handlePreview">{{ formData.spotCheckFileName }}</el-button>
                    <span v-else>{{ formData.spotCheckFileName }}</span>
                </el-col>
                <el-col class="has-bg center-text" :span="3">附件下载</el-col>
                <el-col class="center-text" :span="5"><el-button type="primary" size="mini" @click="handleDownload">下载附件</el-button></el-col>
            </el-row>
            <el-row>
                <el-col class="has-bg center-text" :span="3">模板下载</el-col>
                <el-col class="center-text" :span="5"><el-button v-if="btnVisible" type="primary" size="mini" @click="handleTemp">下载模板</el-button></el-col>
                <el-col class="has-bg center-text" :span="3"></el-col>
                <el-col :span="5"></el-col>
                <el-col class="has-bg center-text" :span="3"></el-col>
                <el-col :span="5"></el-col>
            </el-row>
        </div>
        <Preview
            v-if="attachmentShow"
            :attachmentList="attachmentList"
            :attachmentShow.sync="attachmentShow"
            :rowData="rowData"
        ></Preview>
    </div>
</template>

<script>
import { dictWithUrl } from '@/components/lots/api'
import Upload from '../../../components/upload/Index.vue';
import Preview from '../../../components/viewAttachment.vue';
import { OSS_FILE_MAX_SIZE } from '../../../constant/constant.js';
import { saveSpotCheckFile } from '../../../api/newSupCheckPool.js';

export default {
    components: { Upload, Preview },
    props: {
        auditId: {
            type: String,
            default: ''
        },
        info: {
            type: Object,
            default: ({})
        },
        auditStatus: {
            type: String,
            default: ''
        },
    },
    data() {
        return {
            OSS_FILE_MAX_SIZE,
            contentVisible: true,
            uploading: false,
            dictData: {},
            formData: {
                spotCheckCode: '',
                spotCheckFileId: '',
                spotCheckFileUrl: '',
                spotCheckFileName: '',
            },
            attachmentShow: false,
            rowData: {},
            attachmentList: [],
            attachmentHasDone: false, // 判断是否已经上传了附件并已入库
        }
    },
    computed: {
        btnVisible() {
            // 草稿00 撤回30 驳回80
            return ['00', '30', '80'].includes(this.auditStatus)
        }
    },
    methods: {
        loadDictData() {
            dictWithUrl('SRM_TEMPLATE_COLLECTION')
                .then(res => {
                    if (res && +res.code === 0) {
                        this.dictData = res.data
                    }
                })
                .catch(err => {})
        },
        setFormData(data) {
            if (!data) return
            this.formData.spotCheckCode = data.spotCheckCode || ''
            this.formData.spotCheckFileId = data.spotCheckFileId || ''
            this.formData.spotCheckFileUrl = data.spotCheckFileUrl || ''
            this.formData.spotCheckFileName = data.spotCheckFileName || ''
            this.attachmentHasDone = !!data.spotCheckFileUrl
        },
        handlePreview() {
            this.rowData = {
                downUrl: this.formData.spotCheckFileUrl,
                fileName: this.formData.spotCheckFileName,
                fileId: this.formData.spotCheckFileId
            };
            this.attachmentShow = true;
        },
        handleCollapse() {
            this.contentVisible = !this.contentVisible
        },
        handleUploadSuccess(data) {
            if (data.data && data.data.code === '0') {
                this.formData.spotCheckFileId = data.data.data.id
                this.formData.spotCheckFileName = data.data.data.localFileName
                this.formData.spotCheckFileUrl = data.data.data.downUrl
                const params = { ...this.formData }
                this.uploading = true
                saveSpotCheckFile(params).then(res => {
                    if (res && +res.code === 0) {
                        this.$message.success('附件上传成功!')
                        this.attachmentHasDone = true
                    }
                }).finally(() => { this.uploading = false })
            }
        },
        // 下载附件
        handleDownload() {
            if (this.formData.spotCheckFileUrl) {
                const a = document.createElement('a');
                a.href = this.formData.spotCheckFileUrl;
                a.download = this.formData.spotCheckFileName;
                a.click();
            } else {
                this.$message.warning('暂无附件')
            }
        },
        handleTemp() {
            if (this.dictData.SRM_TEMPLATE_COLLECTION && this.dictData.SRM_TEMPLATE_COLLECTION.NEW_SUP_CHECK) {
                const a = document.createElement('a');
                a.href = this.dictData.SRM_TEMPLATE_COLLECTION.NEW_SUP_CHECK;
                a.download = '新供应商点检池模板.xlsx';
                a.click();
            } else {
                this.$message.warning('暂无模板')
            }
        },
        uploadValidate() {
            return this.attachmentHasDone
        },
    },
    mounted() {
        this.loadDictData()
        this.setFormData(this.info)
    },
}
</script>

<style lang="less">
.nscp-contract-info {
    margin-bottom: 20px;
    font-size: 14px;
    color: #000;

    .el-row {
        display: flex;
        width: 100%;
    }

    .el-col {
        float: none;
    }

    .sub-title {
        display: inline-block;
        font-weight: bold;

        &::before {
            display: inline-block;
            margin-right: 5px;
            width: 5px;
            height: 14px;
            background: #000;
            content: '';
            vertical-align: middle;
        }
    }

    .title-container {
        margin-top: 15px;
        margin-bottom: 5px;

        i {
            float: right;
            padding-right: 10px;
            font-size: 24px;
            cursor: pointer;
        }
    }

    .content {
        border-top: 1px solid #ddd;
        border-left: 1px solid #ddd;
    }

    .has-bg {
        background: #f5f7fa;
    }

    .center-text {
        text-align: center;
    }

    .el-col {
        padding: 5px;
        border-right: 1px solid #ddd;
        border-bottom: 1px solid #ddd;
        min-height: 30px;
    }

    .tip {
        color: red;
        font-size: 12px;
        font-weight: normal;
        display: inline-block;
        margin-left: 10px;
    }

    .el-button--text {
        width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .upload_button {
        padding: 7px;
    }
}
</style> 